// routes.js

import { createBrowserRouter } from "react-router-dom";
import HomePage from "../pages/home";
import DishMaterial from "../pages/dish-material";
import Layout from "../components/layout";
import DishPackagingInfo from "../pages/dish-packaging-info";
import EnquireVendors from "../pages/enquire-vendors";
import VendorCatalog from "../pages/vendor-catalog";
import DirectEnquireVendors from "../pages/direct-enquire-vendors";
import EnquireVendorsPackaging from "../pages/enquire-vendors-packaging";
import FaqPage from "../pages/faq-page";
import Sustainability from "../pages/sustainability";
import PageNotFound from "../pages/page-not-found";
import TermsofUse from "../pages/terms-of-use";
import PrivacyPolicy from "../pages/privacy-policy";
// import PageNotFound from "../pages/page-not-found";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />, // Wrap routes inside Layout
    children: [
      { path: "", element: <HomePage /> }, // Renders inside Layout
      {
        path: ":category/:subCategoryURL/packaging-options",
        element: <DishMaterial />,
      },
      {
        path: ":category/:subCategoryURL",
        element: <DishPackagingInfo />,
      },
      {
        path: "enquire-vendors/:productUrl",
        element: <EnquireVendors />,
      },
      { path: "raise-an-enquiry", element: <DirectEnquireVendors /> },
      { path: ":vendorUrl", element: <VendorCatalog /> },
      {
        path: "enquiry",
        element: <EnquireVendorsPackaging />,
      },
      {
        path: "sustainability",
        element: <Sustainability />,
      },
      {
        path: "/faqs",
        element: <FaqPage />,
      },
      {
        path: "/terms-of-use",
        element: <TermsofUse />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

export default router;
